/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Animated(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0011 3.5C17.0011 2.11929 18.1204 1 19.5011 1C20.8818 1 22.0011 2.11929 22.0011 3.5C22.0011 4.88071 20.8818 6 19.5011 6C18.1204 6 17.0011 4.88071 17.0011 3.5ZM11.0298 14.8947L11.0384 14.885L10.3267 14.2373L10.3267 14.2372C9.33268 13.3324 9.25539 11.7949 10.1537 10.7951L10.1541 10.7946L14.2219 6.25059L12.5993 4.82503L12.5993 4.82502C12.386 4.6376 12.062 4.65545 11.8705 4.86505L11.8705 4.86505L11.8681 4.86766L9.62872 7.29647L9.12033 7.84786L8.01754 6.83108L8.52593 6.27968L10.7629 3.85348L10.7643 3.85195C11.5071 3.04037 12.7627 2.97189 13.5893 3.69816L13.5893 3.69816L17.7673 7.36888L17.7673 7.3689C18.2956 7.8331 18.5985 8.50232 18.5985 9.20562V11.828V11.9152C18.5985 12.203 18.8319 12.4364 19.1197 12.4364H22.0011H22.7511V13.9364H22.0011H19.1197C18.0035 13.9364 17.0985 13.0314 17.0985 11.9152V10.3506L13.147 14.7758L14.8025 16.2825L14.8025 16.2825C15.6173 17.0241 15.688 18.2817 14.9617 19.1099L14.9605 19.1113L12.0158 22.4925L11.5232 23.0581L10.3921 22.073L10.8846 21.5074L13.8314 18.1237L13.8336 18.1213C14.0212 17.9078 14.0031 17.5832 13.7929 17.3919L13.7928 17.3918L12.0562 15.8113L11.0298 14.8947ZM16.2335 9.06728L12.0376 13.7661L11.3364 13.128L11.3364 13.1279C10.9521 12.7781 10.9224 12.1838 11.2697 11.7974L11.2707 11.7962L15.3488 7.24067L16.7585 8.4793L16.2335 9.06728ZM5.75254 16.4339C5.96613 16.6215 6.2907 16.6033 6.48204 16.3931L6.49402 16.3802L8.28042 14.5077L8.79811 13.965L9.88346 15.0004L9.36576 15.543L7.58476 17.41C6.84282 18.2174 5.59158 18.286 4.7658 17.5636L1.51181 14.763L0.943359 14.2738L1.92185 13.1369L2.4903 13.6261L5.74683 16.4289L5.74685 16.4289L5.75254 16.4339Z"
        fill="currentColor"
      />
    </svg>
  )
}

Animated.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Animated
